import gtmVoucher from 'services/AirBaltic/GTM/Voucher'
import SearchSessionStorageMixin from './SearchSessionStorage'

const PromoCodesMixin = {
  mixins: [SearchSessionStorageMixin],
  methods: {
    showPromoCodeBlock() {
      gtmVoucher.clickOnVoucherLink()
      this.$store.dispatch('eHorizonSearchForm/promoCodes/toggleBlock', true)
    },
    openPromoModal() {
      this.$store.commit('eHorizonSearchForm/promoCodes/showDropdown', true)
      this.$store.commit('eHorizonSearchForm/promoCodes/setInvalid', true)
    },
    closePromoModal() {
      this.$store.commit('eHorizonSearchForm/promoCodes/showDropdown', false)
    },
    closeAndHidePromoModal() {
      this.$store.commit('eHorizonSearchForm/promoCodes/showDropdown', false)
      this.$store.dispatch('eHorizonSearchForm/promoCodes/toggleBlock', false)
    },
    onPromoCodeAdded() {
      this.$store.commit('eHorizonSearchForm/promoCodes/add')
    },
    onPromoCodeUpdated(index, value, updateSession = false) {
      this.$store.commit('eHorizonSearchForm/promoCodes/update', {
        index,
        code: value,
        error: ''
      })

      if (updateSession) {
        this.$_searchSessionStorageMixin_updateVoucherSessionStorage()
      }
    },
    onPromoCodeRemoved(index, updateSession = false) {
      this.$store.commit('eHorizonSearchForm/promoCodes/remove', index)

      if (updateSession) {
        this.$_searchSessionStorageMixin_updateVoucherSessionStorage()
      }

      this.$store.dispatch('eHorizonSearchForm/promoCodes/validateForm')
    }
  }
}

export default PromoCodesMixin
